import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import useOnclickOutside from 'react-cool-onclickoutside';
import PropTypes from 'prop-types';
import { formDataFromServerShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import {
  SpeachMark,
  SpeachMarkFilled,
} from 'AppSrc/core/components/common/svg-icons';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import {
  // getArraySortedByProperty,
  // sortNullableValues,
  getArraySortedWithDirectionByProperty,
} from 'AppSrc/core/utility-functions/sort-functions';
import 'AppSrc/core/style/components/view-crq-screen/view-crq-approvers-history.css';
import {
  CHANGE_TYPE,
  CHANGE_QUESTIONS,
  WORK_INFORMATION_ITEMS,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import {
  FIXED,
  MOBILE,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import { getCoordinatorGroupMembers } from 'AppSrc/core/coordinators/coordinator-queries';
import { getDateDisplay } from 'AppSrc/core/crq/crq-table-utils';
import { AllApproverTableDisplay } from './view-crq-select-individual-approver';
import { AllApproverViewTableDisplay } from './view-crq-view-individual-approver';
import { RevokeApprovalGranted } from './view-crq-revoke-approval-granted';
import { ApprovalButton } from './view-crq-approvals-button';


const ViewCrqApprovalsHistory = ({
  formData,
  userLoggedIn,
  isAssignedCoordinator,
  userGroups,
  crqId,
  hasApproverAssigned,
  isEmergencyCrq,
}) => {
  const {
    approvalHistory,
  } = formData;
  hasApproverAssigned();
  const revokeUserId = useSelector((state) => state.auth.user.remedyIds.fixed);
  const crqStatus = formData.status;
  const network = formData.dataByFormSectionId[CHANGE_TYPE].dataByFieldId.select_network.value[0];
  const Peerlist = [];
  const newApprovalHistory = approvalHistory.map((element, index) => {
    if (network === 'fixed') {
      const impact = formData.dataByFormSectionId[CHANGE_QUESTIONS].dataByFieldId.impact.value;
      if (formData.status === '5' && element.type === 'Peer' && element.status === 'Approved' && (impact === '1000' || impact === '2000')) {
        Peerlist.push(element);
        return null;
      }
    }
    return element;
  });

  const approvalValue = newApprovalHistory.filter((value) => value !== null);
  const newpeerlist = Peerlist.map((element, index) => {
    if (index % 2 === 0) {
      return element;
    }
    return null;
  });

  const newpeerhistory = newpeerlist.filter((value) => value !== null);
  const finalApproval = approvalValue.concat(newpeerhistory);

  const [activeComments, setActiveComments] = useState([]);
  const [revokeActiveComments, setRevokeActiveComments] = useState([]);
  const finalApprovalSorted = getArraySortedWithDirectionByProperty({
    array: finalApproval,
    propKey: 'date',
    sortDescending: true,
    nullsLast: false,
  });
  const isApproverAssigned = finalApprovalSorted.some((items) => items.actionable === true);
  hasApproverAssigned(isApproverAssigned);

  // Func return boolean array based on status and type condition
  const peerApprovedFlag = (historydatalist) => {
    const flagReady = historydatalist.map((historyelement) => {
      if (historyelement.status === 'Approved' && historyelement.type === 'Peer') {
        return true;
      }
      return false;
    });
    return flagReady;
  };

  const statusFlagList = peerApprovedFlag(finalApprovalSorted);
  // Filtered boolean array based on true
  const filteredStatusFlagTrue = statusFlagList.filter((elem) => (elem === true));
  const isStatusApproved = filteredStatusFlagTrue.length > 0 ? true : false;

  // Set empty array and push true elements index number to the approvedStatusIndexes
  const approvedStatusIndexes = [];
  statusFlagList.forEach((approvalStatusValue, index) => (approvalStatusValue === true ? approvedStatusIndexes.push(index) : null));

  const toggleActiveComment = (id) => {
    if (activeComments.includes(id)) {
      const newActiveComments = activeComments.filter((activeId) => activeId !== id);
      setActiveComments(newActiveComments);
      return null;
    }
    const newActiveComments = [
      ...activeComments,
      id,
    ];
    setActiveComments(newActiveComments);
    return null;
  };
  // This is for showing the the revoke reason in approval history based on onclick of comment.
  const revokeToggleActiveComment = (id) => {
    if (revokeActiveComments.includes(id)) {
      const revokeNewActiveComments = revokeActiveComments.filter((activeId) => activeId !== id);
      setRevokeActiveComments(revokeNewActiveComments);
      return null;
    }
    const revokeNewActiveComments = [
      ...revokeActiveComments,
      id,
    ];
    setRevokeActiveComments(revokeNewActiveComments);
    return null;
  };

  const [groupMembers, setGroupMembers] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [isfulltabledisplay, setTableDisplay] = useState('');
  const [isApproverSignature, setIsApproverSignature] = useState('');
  const assign = 'Assign';
  const reAssign = 'Re-Assign';
  const view = 'View';

  const approval = (peers, group, peer, isAssign, isReAssign, isViewOnly) => {
    if (isAssign === true && isReAssign === false) {
      return assign;
    }
    if (isReAssign === true && isAssign === false) {
      return reAssign;
    }
    if (isViewOnly === true) {
      return view;
    }
    return false;
  };

  const onClickDisappear = (approvalList) => {
    setIsFetching(false);
    setTableDisplay(null);
    return true;
  };

  const ref = useOnclickOutside(() => {
    setTableDisplay(null);
  },
  { ignoreClass: 'alert-section' });


  const onClickAssign = (networkType, groupid, buttonType, approvalrequestId) => {
    setIsFetching(true);
    getCoordinatorGroupMembers(networkType, groupid, crqStatus).then((results) => {
      // DISPATCH HERE FREYJA
      setGroupMembers([...results]);
      setTableDisplay(buttonType);
      // setIsFetching(false);
      setIsApproverSignature(approvalrequestId);
    });
  };

  return (
    <div className="vf-table approvals-history-table">
      <div className="vf-table-head-container">
        <div
          className="vf-table-head approvals-history-table-head"
        >
          <div className="start-date start-date-head head-item">
            <span className="head-text">
              Date
            </span>
          </div>

          <div className="type type-head head-item">
            <span className="head-text">
              Type
            </span>
          </div>

          <div className="group group-head head-item">
            <span className="head-text">
              Group
            </span>
          </div>

          <div className="approver approver-head head-item">
            <span className="head-text">
              Approver
            </span>
          </div>

          <div className="status status-head head-item">
            <span className="head-text">
              Status
            </span>
          </div>
        </div>
      </div>

      { // The array is in date order, but we want reverse date order
        finalApprovalSorted.map((historyItem, index) => {
          const {
            comment,
            date,
            group,
            groupId,
            peer,
            status,
            type,
            assignee,
            id,
            signature,
            userId,
          } = historyItem;
          const placeHolder = '-';
          const activeComment = activeComments.includes(id);
          const revokeActiveComment = revokeActiveComments.includes(id);
          const approvalStatus = status;
          // Passing date as well as time in ISO format for entries of Approvals Type, Peer review entries will continue to receive only date.
          const formattedDate = historyItem.type === 'Approvals' ? getDateDisplay(date) : date;
          // const groups = group ? placeHolder : userId;
          let peers = peer ? peer : assignee;
          if ((network === 'fixed' || network === 'mobile' || network === 'fixedInternational') && signature && groupId === null && type === 'Approvals' && peers === undefined && approvalStatus === 'Pending') {
            peers = userId ? userId : assignee;
          }
          const isCorrectFixedApprover = () => (userGroups[FIXED]) && (userGroups[FIXED].includes(group));
          const isCorrectMobileApprover = () => (userGroups[MOBILE]) && (userGroups[MOBILE].includes(group));

          let isAssign = '';
          let isReAssign = '';
          let isViewOnly = '';
          let canView = '';
          let groupRevoke = '';
          let individualRevoke = '';

          // All the logic here are for showing revoke button for objects with approver groups
          const pendingStatus = 'Pending';
          const newFilteredGroupArray = finalApprovalSorted.filter((abc) => (abc.groupId === groupId && abc.groupId !== null) && abc.type === 'Approvals');
          const pendingInclusion = newFilteredGroupArray.map((object) => object.status).includes(pendingStatus);
          const latestGroupSignature = Math.max(...newFilteredGroupArray.map((object) => object.signature));
          const approvedSignatureGroupArray = newFilteredGroupArray.filter((xyz) => (xyz.status === 'Approved'));
          // const filteredLatestGroupSignature = latestGroupSignature.filter((object) => (object.status === 'Approved'));
          // Below here is the logic for finding the latest signature for approved items from Group Array. If revoke has reached its limit of 2
          // Then first latest signature is found, it is then filtered and latest signature is eliminated and
          // then again latest signature is calculated among rest of the 2 items.
          let latestRevoked = '';
          if (approvedSignatureGroupArray.length > 2) {
            const maxSignature = Math.max(...approvedSignatureGroupArray.map((object) => object.signature));
            const eliminatedLatestRevoked = approvedSignatureGroupArray.filter((number) => number.signature !== '000000000'.concat(maxSignature));
            latestRevoked = Math.max(...eliminatedLatestRevoked.map((object) => object.signature));
          }
          else {
            latestRevoked = Math.max(...approvedSignatureGroupArray.map((object) => object.signature));
          }

          // All the below logics here are for showing the revoke button for objects with individual approver.
          const newFilteredArrayindividual = finalApprovalSorted.filter((abc) => (abc.groupId === null || abc.groupId === undefined) && abc.userId === userId);
          const individualPendingInclusion = newFilteredArrayindividual.map((object) => object.status).includes(pendingStatus);
          const latestSignature = Math.max(...newFilteredArrayindividual.map((object) => object.signature));
          const approvedIndividualArray = newFilteredArrayindividual.filter((object) => (object.status === 'Approved'));

          let latestIndividualRevoked = '';
          if (approvedIndividualArray.length > 2) {
            const maxIndividualSignture = Math.max(...approvedIndividualArray.map((object) => object.signature));
            const eliminatedLatestIndividualRevoked = approvedIndividualArray.filter((number) => number.signature !== '000000000'.concat(maxIndividualSignture));
            latestIndividualRevoked = Math.max(...eliminatedLatestIndividualRevoked.map((object) => object.signature));
          }
          else {
            latestIndividualRevoked = Math.max(...approvedIndividualArray.map((object) => object.signature));
          }

          const validSignature = type === 'Approvals' ? signature.includes(latestGroupSignature) : null;
          const validIndividualSignature = type === 'Approvals' ? signature.includes(latestSignature) : null;
          const validLatestGroupRevokeSignature = type === 'Approvals' ? signature.includes(latestRevoked) : null;
          const validLatestIndividualRevokeSignature = type === 'Approvals' ? signature.includes(latestIndividualRevoked) : null;

          if (network === 'fixed') {
            isAssign = isCorrectFixedApprover() && peers === undefined && approvalStatus === 'Pending';
            isReAssign = isCorrectFixedApprover() && peers !== undefined && approvalStatus === 'Pending';
            isViewOnly = isAssignedCoordinator && !isCorrectFixedApprover() && approvalStatus === 'Pending';
            // canView = groupId === null ? false : isCorrectFixedApprover() || isAssignedCoordinator;
            canView = (isCorrectFixedApprover() || isAssignedCoordinator || ([userId].length === 1 && userId === userLoggedIn));
            individualRevoke = (canView === true && formData.status === '5' && peers !== undefined && group === null && approvalStatus === 'Approved' && individualPendingInclusion === false && newFilteredArrayindividual.length < 3 && ((signature.includes(latestSignature)) || (newFilteredArrayindividual.length === 1 && approvalStatus === 'Approved')));
            groupRevoke = (canView === true && formData.status === '5' && pendingInclusion === false && (approvalStatus === 'Approved') && ((validSignature === true) || (newFilteredGroupArray.length === 1 && approvalStatus === 'Approved')) && newFilteredGroupArray.length < 3 && type === 'Approvals' && (group !== '-' || group !== null));
          }
          if (network === 'mobile') {
            isAssign = isCorrectMobileApprover() && peers === undefined && approvalStatus === 'Pending';
            isReAssign = isCorrectMobileApprover() && peers !== undefined && approvalStatus === 'Pending';
            isViewOnly = isAssignedCoordinator && !isCorrectMobileApprover() && approvalStatus === 'Pending';
            canView = isCorrectMobileApprover() || isAssignedCoordinator;
            // isRevoke = isCorrectMobileApprover() && peers === undefined && approvalStatus === 'Approved';
          }
          const approvalList = approval(peers, group, peer, isAssign, isReAssign, isViewOnly);
          // Below is the logic for extracting the notes from work info item data for revoked approvals.
          const wiiId = 'work-information-items';
          const workItemList = formData.dataByFormSectionId[WORK_INFORMATION_ITEMS].dataByFieldId[wiiId].value.dataByFormSectionId;
          let revokeWorkItem = '';
          let generalInfoWorkItem = [];
          let hasRevokeReason = false; // ((revokeMailId === userId) && (approvalStatus === 'Approved')) ? true : false;
          const newWorkItem = Object.entries(workItemList).map((item) => {
            const dateFlag = date === item[1].submitted ? true : false;
            console.log('loopdate', dateFlag);
            if (item[1].dataByFieldId.summary.value === 'Revoked Approval for CRQ') {
              revokeWorkItem = item;
              return item;
            }
            return null;
          });

          const revokeNoteWii = Object.entries(workItemList).map((item2, index1) => {
            const worklog = 'work_items';
            if (item2[1].dataByFieldId[worklog].value === '29000') {
              generalInfoWorkItem = item2[1].notes;
              return item2[1].notes;
            }
            return null;
          });
          console.log('newWorkwii', newWorkItem, generalInfoWorkItem);
          const revokeCommentArray = revokeNoteWii.filter((message) => (message !== null));
          const revokeMailId = revokeWorkItem[1] !== undefined ? revokeWorkItem[1].notes.split(' ') : '';

          if (userId !== undefined && userId.includes(';') === true && approvalStatus === 'Approved' && groupRevoke !== true && validSignature === false) {
            hasRevokeReason = userId.includes(revokeMailId[0]);
          }

          if (userId !== undefined && userId.includes(';') === false && approvalStatus === 'Approved' && individualRevoke !== true && validIndividualSignature === false) {
            hasRevokeReason = userId === (revokeMailId[0]) ? true : false;
          }
          let groupCancelReason = '';
          let individualCancelReason = '';

          const groupArraycontainMessage = revokeCommentArray.filter((eachComment) => {
            const eachCommentArray = eachComment.split(' ');
            return eachCommentArray[1] === groupId;
          });
          const containMessageNullGroup = revokeCommentArray.filter((eachComment) => {
            const eachCommentNullArray = eachComment.split(' ');
            return eachCommentNullArray[1] === 'null';
          });

          let isValidGroupId = false;
          if (groupArraycontainMessage.length > 0) {
            isValidGroupId = (groupArraycontainMessage[0].includes(groupId) === true) ? true : false;
          }

          let isValidIndividual = false;
          if (containMessageNullGroup.length > 0) {
            isValidIndividual = (containMessageNullGroup[0].includes(userId) === true) ? true : false;
          }
          // This is for mapping of revoke cancellation reason having group approvers to correct elemnt in approval history row.
          if (groupId !== null && type !== 'Peer' && isValidGroupId === true) {
            const containMessage = revokeCommentArray.filter((eachComment) => (eachComment.includes(groupId) === true));

            if (containMessage.length === 1) {
              groupCancelReason = containMessage.length > 0 ? containMessage[0].split(' ').slice(2).join(' ') : '';
            }
            if (containMessage.length >= 1 && validLatestGroupRevokeSignature === false) {
              groupCancelReason = containMessage.length > 0 ? containMessage[0].split(' ').slice(2).join(' ') : '';
            }
            if (containMessage.length > 1 && validLatestGroupRevokeSignature === true) {
              groupCancelReason = containMessage.length > 0 ? containMessage[1].split(' ').slice(2).join(' ') : '';
            }
          }
          // This is for mapping of revoke cancellation reason having individual approvers to correct elemnt in approval history row.
          if ((type !== 'Peer' && isValidIndividual === true)) {
            const containMessageIndividual = revokeCommentArray.filter((dummy) => (dummy.includes('null')));

            if (containMessageIndividual.length === 1) {
              individualCancelReason = containMessageIndividual.length > 0 ? containMessageIndividual[0].split(' ').slice(2).join(' ') : '';
            }
            if (containMessageIndividual.length > 1 && validLatestIndividualRevokeSignature === false) {
              individualCancelReason = containMessageIndividual.length > 0 ? containMessageIndividual[0].split(' ').slice(2).join(' ') : null;
            }
            if (containMessageIndividual.length > 1 && validLatestIndividualRevokeSignature === true) {
              individualCancelReason = containMessageIndividual.length > 0 ? containMessageIndividual[1].split(' ').slice(2).join(' ') : null;
            }
          }

          let typeNew = '';
          // get index number for circuit check row based on + 1 with prev peer approved status index
          const indexMatch = () => (approvedStatusIndexes.find((eachTrueIndex) => (index === eachTrueIndex + 1)));
          // Itrerate array with approved status index list and update text
          approvedStatusIndexes.map(() => {
            if (isStatusApproved && (indexMatch() !== undefined) && (type === 'Peer') && (status === 'Rejected')) {
              typeNew = 'Change Management';
            }
            if (isStatusApproved && (isEmergencyCrq === true) && type === 'Peer') {
              typeNew = 'L3 Approver';
            }
            else {
              typeNew = type;
            }
            return typeNew;
          });
          // This is for showing status of entries that are revoked as cancelled.since a CRQ can be revoked max 2 times,
          // the last entry would be shown as approved without any change, if a CRQ has been approved.
          let newStatus = '';

          if (type === 'Approvals' && status === 'Approved' && (validSignature === false) && (validIndividualSignature !== true)) {
            newStatus = 'Cancelled';
          }
          else {
            newStatus = status;
          }

          return (
            <div
              className="vf-table-row-container"
              key={id}
            >
              <div
                className="vf-table-row"
              >
                <div className="top-row">
                  <div className="start-date start-date-row row-item">
                    <span className="row-item-text">
                      {formattedDate ? formattedDate : '--/--/----'}
                    </span>
                  </div>

                  <div className="type type-row row-item">
                    <span className="row-item-text">
                      {/* initially type was comming for peer and approvals, now typeNew contains status and type from peer, circuit check and approvals */}
                      {typeNew ? typeNew : placeHolder}
                    </span>
                  </div>

                  <div className="group group-row row-item">
                    <span className="row-item-text" data-tip={group}>
                      {group ? group : placeHolder}
                    </span>
                    <ReactTooltip />
                  </div>

                  <div className="approver approver-row row-item">
                    <span className="row-item-text" data-tip={peers}>
                      {peers ? peers : placeHolder}
                    </span>
                    <ReactTooltip />
                  </div>

                  <div className={`status status-row${(comment || (hasRevokeReason === true)) ? ' has-comment' : ''} row-item`} ref={ref}>
                    <span className="row-item-text">
                      {status ? newStatus : placeHolder}
                    </span>
                    {
                      comment && (
                        <OptionButton
                          className="toggle-comment-button"
                          onClick={toggleActiveComment}
                          option={id}
                        >
                          {
                            activeComment ? (
                              <SpeachMarkFilled />
                            ) : (
                              <SpeachMark />
                            )
                          }
                        </OptionButton>
                      )
                    }
                    {
                      canView === true && groupId !== null && formData.status === '5' && type === 'Approvals' && (approvalStatus === 'Pending') && (
                        <ApprovalButton
                          groupMembers={groupMembers}
                          isFetching={isFetching}
                          onClickDisappear={onClickDisappear}
                          network={network}
                          crqId={crqId}
                          updateValue={groupMembers}
                          value={setGroupMembers}
                          isViewOnly={isViewOnly}
                          isAssign={isAssign}
                          isReAssign={isReAssign}
                          onClickAssign={onClickAssign}
                          buttonName={approvalList}
                          group={group}
                          groupId={groupId}
                          slectedNetwork={network}
                          approvalSignature={signature}
                        />
                      )
                    }
                    {
                      isfulltabledisplay === 'View' && (
                        <AllApproverViewTableDisplay
                          groupMembers={groupMembers}
                          isFetching={isFetching}
                          onClickDisappear={onClickDisappear}
                          network={network}
                          crqId={crqId}
                          updateValue={groupMembers}
                          value={setGroupMembers}
                          isViewOnly={isViewOnly}
                          isAssign={isAssign}
                          isReAssign={isReAssign}
                        />
                      )
                    }
                    {
                      ((isFetching) && isfulltabledisplay === 'Re-Assign' || isfulltabledisplay === 'Assign') && (
                        <AllApproverTableDisplay
                          groupMembers={groupMembers}
                          isFetching={isFetching}
                          onClickDisappear={onClickDisappear}
                          network={network}
                          crqId={crqId}
                          updateValue={groupMembers}
                          value={setGroupMembers}
                          isViewOnly={isViewOnly}
                          isAssign={isAssign}
                          isReAssign={isReAssign}
                          approvalSignature={isApproverSignature}
                        />
                      )
                    }
                    {
                      ((groupRevoke === true) || (individualRevoke === true)) && (
                        <RevokeApprovalGranted
                          groupId={groupId}
                          group={group}
                          crqId={crqId}
                          email={userLoggedIn}
                          userId={userId}
                          fullName={peers}
                          network={network}
                          revokeUserId={revokeUserId}
                        />
                      )
                    }
                    {
                      (hasRevokeReason === true) && (
                        <OptionButton
                          className="svg-btn-revoke-comment toggle-comment-button"
                          onClick={revokeToggleActiveComment}
                          option={id}
                        >
                          {
                            hasRevokeReason ? (
                              <SpeachMarkFilled />
                            ) : (
                              <SpeachMark />
                            )
                          }
                        </OptionButton>
                      )
                    }
                  </div>
                </div>
              </div>
              {
                activeComment && (
                  <div className="comment-text-container">
                    <span className="comment-text">
                      {comment}
                    </span>
                  </div>
                )
              }
              {
                revokeActiveComment && (
                  <div className="comment-text-container">
                    <span className="comment-text">
                      {(groupId !== null && type !== 'Peer' && isValidGroupId === true) ? groupCancelReason : individualCancelReason}
                    </span>
                  </div>
                )
              }
            </div>
          );
        })
      }
    </div>
  );
};


ViewCrqApprovalsHistory.propTypes = {
  formData: formDataFromServerShape,
  userLoggedIn: PropTypes.string,
  userGroups: PropTypes.objectOf(PropTypes.array),
  crqId: PropTypes.string,
  isAssignedCoordinator: PropTypes.bool,
  hasApproverAssigned: PropTypes.func,
  isEmergencyCrq: PropTypes.bool,
};


export {
  ViewCrqApprovalsHistory,
};





